import domain from '@/util/domain.js';
export default {
  install(Vue) {
    Vue.prototype.$domain = () => {
      return domain();
    }
  }
}